import {Injectable} from '@angular/core';
import {Geschaeftsvorgang} from "../../components/index/service/Model/Lieferung";

@Injectable()
export class CsvExport {

  private static readonly COLUMN_DELIMITER: string = ';';
  private static readonly  LINE_DELIMITER: string = '\n';
  private static readonly  DEFAULT_EXPORT_FILE_NAME: string = 'export.csv';

  downloadCSV(args) {
    let csv = this.convertToCSV(args);
    if (csv == null) return;

    let filename = args.filename || CsvExport.DEFAULT_EXPORT_FILE_NAME;
    CsvExport.startDownloadProcess(filename, csv);
  }

  private convertToCSV(args) {
    let result, keys, columnDelimiter, lineDelimiter;
    let data: Geschaeftsvorgang[];

    data = args.data || null;
    if (data == null || !data.length) {
      return null;
    }
    columnDelimiter = args.columnDelimiter || ';';
    lineDelimiter = args.lineDelimiter || '\n';
    keys = args.keys || Object.keys(data[0]);
    result = keys.join(columnDelimiter);
    result += lineDelimiter;
    data.forEach(function (item) {
      keys.forEach(function (key,ctr) {
        if (ctr > 0) result += columnDelimiter;
        result += item[key];
      });
      result += lineDelimiter;
    });
    return result;
  }

  public downloadAsCSV(inputData: any[], propertyNames2Use: Property2ReadableName[], outputFileName?: string) {
    let csv = this.convert2CSVFormat(inputData, propertyNames2Use);
    if (csv == null) return;

    let exportFileName = outputFileName || CsvExport.DEFAULT_EXPORT_FILE_NAME;
    CsvExport.startDownloadProcess(exportFileName, csv);
  }

  private static startDownloadProcess(outputFileName: string, inputDataCsvFormatted: string) {
    let csvData = new Blob(['\ufeff' + inputDataCsvFormatted], {type: 'text/csv;charset=utf-8;'});

    if (navigator.msSaveBlob) {
      // IE11 & Edge
      navigator.msSaveBlob(csvData, outputFileName);
    } else {
      let data = window.URL.createObjectURL(csvData);
      let link = document.createElement('a');
      link.setAttribute('href', data);
      link.setAttribute('download', outputFileName);
      document.body.appendChild(link); // Required for FF
      link.click();
      document.body.removeChild(link);
    }
  }

  public convert2CSVFormat<T>(inputData: T[], propertyNames2Use: Property2ReadableName[]): string {
    let formattedHeader: string = propertyNames2Use.map(value => value.readableName).join(CsvExport.COLUMN_DELIMITER);

    // if no data available avoid to produce a new line => just return headline
    if (null == inputData || 0 == inputData.length) {
      return formattedHeader;
    }

    let formattedInputData: string = inputData
      .map(this.maskNecessarilyFields)
      .map(dataRow => propertyNames2Use.map(value => dataRow[value.propertyName]).join(CsvExport.COLUMN_DELIMITER))
      .join(CsvExport.LINE_DELIMITER);

    return [formattedHeader, formattedInputData].join(CsvExport.LINE_DELIMITER);
  }

  private maskNecessarilyFields<T>(inputObject: T): T {
    Object.keys(inputObject).map( property => {
      // mask only if field value contain {@link CsvExport.COLUMN_DELIMITER}
      if (null != inputObject[property] && inputObject[property].includes(CsvExport.COLUMN_DELIMITER)) {
        inputObject[property] = "\"" + inputObject[property] + "\"";
      }
    });
    return inputObject;
  }

}

export interface Property2ReadableName {
  /**
   * Property name used in object declaration
   */
  propertyName: string;

  /**
   * Name used as "human readable/understanding" for assigned propertyName
   */
  readableName: string;
}
